// extracted by mini-css-extract-plugin
export default {"container":"Payment_container__oBsC8","title":"Payment_title__yTCL-","url":"Payment_url__pv86t"};